var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canExport)?_c('v-list-item',[_c('router-link',{staticClass:"mr-auto user__link",attrs:{"to":"/conversion-reports"}},[_vm._v(" Conversion reports ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }